import React, { ChangeEvent, useState } from 'react';

import { Plus } from '../icons';
import { useFileDropzone } from '../../hooks/useFileDropzone';
import { selectFiles } from '../../core/services/file.service';

import styles from './photo-uploader.module.scss';

export type ProfilePictureProps = {
  onChange?: (file: File) => void;
  onMultipleChange?: (files: File[]) => void;
  buttonName?: string;
  placeholderTitle?: string;
  placeholderDescription?: string;
  accept?: string;
  multiple?: boolean;
};

export const PhotoUploader: React.FC<ProfilePictureProps> = ({
  onChange,
  onMultipleChange,
  buttonName = 'Add Photo',
  placeholderTitle = 'Drag and drop',
  placeholderDescription = 'JPG, PNG file size no more that 3MB',
  accept = 'image/*',
  multiple,
}) => {
  const [_, setUrl] = useState<string | undefined>();

  const handleChange = (file: File) => {
    setUrl(URL.createObjectURL(file));
    onChange && onChange(file as File);
  };

  const handleFileChange = (files: File[]) => {
    if (multiple && onMultipleChange) {
      return onMultipleChange(files);
    }

    const file = files[0];
    handleChange(file);
  };

  const openFileNavigator = async () => {
    const files = await selectFiles({
      multiple,
      accept,
    });

    if (!files || files.length === 0) {
      return;
    }

    handleFileChange(files);
  };

  const { handleDrop } = useFileDropzone({
    handler: handleChange,
  });

  return (
    <div
      className={styles['upload-container']}
      onDrop={handleDrop}
      id="photo-uploader"
      onClick={openFileNavigator}
    >
      <div className={styles['placeholder']}>
        <div className={styles['icon']}>
          <Plus />
        </div>

        {buttonName}

        <span>
          {placeholderTitle} <br />
          {placeholderDescription}
        </span>
      </div>
    </div>
  );
};
